/** Default server list page size (must match backend MAX_LIST_PAGE_SIZE). */
export const DEFAULT_LIST_PAGE_SIZE = 25;

export const LIST_PAGE_SIZE_OPTIONS = [10, 25];

export const EMPTY_LIST_META = {
  count: 0,
  page: 1,
  page_size: DEFAULT_LIST_PAGE_SIZE,
  total_pages: 0,
  summary: {},
};

/**
 * Build query params from column filters + sort (server-side lists).
 * @param {number} page
 * @param {number} pageSize
 * @param {Record<string, string>} columnFilters
 * @param {{ id: string, desc?: boolean } | null} sorting
 * @param {import('./dataTable').DataTableColumn[]} columns
 * @param {Record<string, string>} [extra]
 */
export function buildListParams(page, pageSize, columnFilters, sorting, columns, extra = {}) {
  const params = { page, page_size: pageSize, ...extra };
  const colMap = Object.fromEntries(columns.map((c) => [c.id, c]));

  for (const [id, value] of Object.entries(columnFilters || {})) {
    if (!value) continue;
    const col = colMap[id];
    if (!col || col.serverParam === false) continue;
    const key = col.serverParam || id;
    params[key] = value;
  }

  if (sorting?.id) {
    const col = colMap[sorting.id];
    const field = col?.sortKey || col?.serverParam || sorting.id;
    params.ordering = `${sorting.desc ? "-" : ""}${field}`;
  }

  return params;
}

/** Fetch all rows for Excel export (`export=1` on list APIs). */
export async function fetchAllForExport(api, path, baseParams = {}) {
  const { data } = await api.get(path, { params: { ...baseParams, export: 1 } });
  const body = data?.results ?? (Array.isArray(data) ? data : []);
  return Array.isArray(body) ? body : [];
}
